export enum InstitutionType {
VocationalEducation,
BasicEducation,
CertificationOrganization,
}
